<div class="popup">
  <div class="popup_content">
    <div class="popup_content_heading">
      <h5 class="modal-title">Execution Configuration for {{ data.suiteName }}</h5>
    </div>
    <div class="popup_content_content">
      <div class="execution-config-form">
        <div class="form-row">
          <div class="form__field">
            <label>Browsers</label>
            <mat-form-field appearance="fill" class="popup">
              <mat-select [(ngModel)]="executionModel.browser" (selectionChange)="onBrowserChange()" multiple>
                <mat-option *ngFor="let browser of browserList" [value]="browser">{{ browser }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form__field">
            <label>Delay in second</label>
            <mat-form-field appearance="fill" class="popup">
              <mat-select [(ngModel)]="executionModel.default_pause" (ngModelChange)="onDefaultPauseChange($event)">
                <mat-option *ngFor="let delay of delayList" [value]="delay.value">{{ delay.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="form-row">
          <div class="form__field">
            <label>Screen Resolution</label>
            <mat-form-field appearance="fill" class="popup">
              <mat-select [(ngModel)]="executionModel.resolution">
                <mat-option *ngFor="let scrResolution of resolutionList" [value]="scrResolution.value">
                  {{ scrResolution.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="executionModel.resolution === 'custom_resolution'" class="custom-resolution">
            <div class="form__field">
              <label>X Dimension:</label>
              <mat-form-field appearance="fill" class="popup">
                <input matInput type="number" [(ngModel)]="xDimension" min="250" max="4000">
              </mat-form-field>
            </div>
            <div class="form__field">
              <label>Y Dimension:</label>
              <mat-form-field appearance="fill" class="popup">
                <input matInput type="number" [(ngModel)]="yDimension" min="250" max="4000">
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form__field">
            <label>{{brand.brandName}} Cloud</label>
            <div class="editable-dropdown">
              <input type="text" [(ngModel)]="selectedOption" [disabled]="executionModel.default_hub || inputboxDisables"
                [placeholder]="brand.brandName + ' Cloud'"
                [ngClass]="{'red-placeholder': executionModel.default_hub, 'black-placeholder': !executionModel.default_hub}"
                readonly />
              <span class="dropdown-icon" (click)="toggleDropdown(!showDropdown)" *ngIf="!executionModel.default_hub">
                <i class="arrow" [class.down]="!showDropdown" [class.up]="showDropdown"></i>
              </span>

              <ul *ngIf="showDropdown" class="dropdown-options">
                <label>Developer System</label>
                <li *ngFor="let option of listofUser" (click)="selectOption(option)">
                  {{ option.username }}
                </li>
                <li *ngIf="listofUser.length === 0" class="no-options">No host found.</li>
                <li (click)="selectOptionforCustom()">Custom IP</li>
              </ul>
            </div>
          </div>

          <div class="form__field" *ngIf="isCustomIpSelected && !executionModel.default_hub">
            <label>Enter Custom IP</label>
            <mat-form-field appearance="fill" class="popup">
              <input matInput [(ngModel)]="customIp" placeholder="Enter IP address" />
            </mat-form-field>
          </div>

          <div class="form__field">
            <label>Port</label>
            <div class="port-container">
              <mat-form-field appearance="fill" class="popup" [class.disabled]="executionModel.default_hub">
                <input
                  matInput
                  [ngModel]="executionModel.port === -1 ? '' : executionModel.port"
                  (ngModelChange)="executionModel.port = $event || -1"
                  [disabled]="(executionModel.isURLWithoutPort || executionModel.default_hub) ? true : null">
              </mat-form-field>
              <mat-checkbox 
                class="check-box custom-checkbox" 
                [(ngModel)]="executionModel.isURLWithoutPort"
                (change)="onIsURLWithoutPortChange()"
                matTooltip="is URL without port">
              </mat-checkbox>
          </div>
        </div>

        <div class="checkbox-row">
          <mat-checkbox [(ngModel)]="executionModel.default_hub" (change)="onCheckboxChange()"
            [matTooltip]="'Run On ' + brand.brandName + ' Hub'">Run On {{brand.brandName}} Hub</mat-checkbox>
          <mat-checkbox [(ngModel)]="executionModel.send_mail"
            matTooltip="Send Notification On Completion">Send Notification On Completion</mat-checkbox>
          <mat-checkbox [(ngModel)]="executionModel.screenshot_required" matTooltip="Visual Comparison">Visual Comparison
          </mat-checkbox>
          <mat-checkbox
            *ngIf="executionModel.default_pause != undefined && executionModel.default_pause !== '0'"
            [(ngModel)]="executionModel.is_implicit_default_pause"
            matTooltip="Implicit Delay">Implicit Delay</mat-checkbox>
        </div>
      </div>
      <div class="popup_content_footer">
        <button class="popup_content_footer_btn" mat-button (click)="cancel()">Cancel</button>
        <button class="popup_content_footer_btn" mat-button (click)="save()">Save Configuration</button>
      </div>
    </div>
  </div>
</div>

